import axios from "axios"
import { Action } from "./actionsShared"
import { server } from "./backend-url"

export const FETCH_USER_OTA_MESSAGES_PREFIX = "FETCH_USER_OTA_MESSAGES"
export const FETCH_APPROVED_DEVICE_VERSIONS_PREFIX = "FETCH_APPROVED_DEVICE_VERSIONS"

export const fetchUserOTAMessages = () => {
  const url = "/ota/messages"
  return Action.GET(FETCH_USER_OTA_MESSAGES_PREFIX, url, true)
}

export const fetchApprovedDeviceVersions = () => {
  const url = "/ota/deviceVersions"
  return Action.GET(FETCH_APPROVED_DEVICE_VERSIONS_PREFIX, url, true)
}

export const createNewOTAMessage = async (deviceId, messageType, message) => {
  const authToken = localStorage.getItem("AuthToken")
  axios.defaults.headers.common = { Authorization: `${authToken}` }
  try {
    await axios.post(`${server}/ota/messages/${deviceId}`, { messageType, message })
    return { deviceId, status: true }
  } catch (e) {
    console.error(e)
    return { deviceId, status: false }
  }
}
